<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <vue-element-loading :active="appLoading2" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex pa-4 xs12 sm12 md6>
        <v-card :outlined="true">
          <v-layout pa-4>
            <v-flex text-left>
              <span style="font-size:16px;font-weight:500">Supporting Evidences</span>
            </v-flex>
            <v-flex v-if="!editProfile" text-right>
              <v-btn
                text
                class="text-capitalize"
                dark
                small
                style="font-size:14px;"
                :ripple="false"
                color="#26af82"
                @click="editProfile=true"
              >Edit</v-btn>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex px-4 pb-4>
              <v-layout pt-4 align="center">
                <v-flex v-if="!editProfile" xs12 sm12 md6 text-left>
                  <span
                    v-if="userType == 'Individual'"
                    style="color:#6A6A6A"
                  >Supporting Evidence Number</span>
                  <span
                    v-if="userType =='Company'"
                    style="color:#6A6A6A"
                  >Company Registration Number</span>
                </v-flex>
                <v-flex v-if="!editProfile" text-left>
                  <span>{{supDocNo}}</span>
                </v-flex>
                <v-flex v-if="editProfile" text-left>
                  <span>Upload new Supporting Documents</span>
                </v-flex>
                <!-- <v-flex v-if="editProfile" text-left>
                  <v-text-field
                    ref="supDocNo"
                    v-model="supDocNo"
                    :rules="[rules.required]"
                    color="#26af82"
                    required
                    height="20"
                  ></v-text-field>
                </v-flex>-->
              </v-layout>
              <v-divider></v-divider>
              <v-layout pt-4 wrap>
                <v-flex xs12 md12>
                  <v-select
                    v-if="userType =='Individual' && editProfile"
                    ref="supportingDoc"
                    :items="supportingDocs"
                    v-model="supportingDoc"
                    :rules="[rules.required]"
                    label="Supporting Evidence"
                    color="#26af82"
                    item-color="#26af82"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex v-if="!editProfile" xs12 sm12 md12 text-left>
                  <span
                    style="font-size:12px;"
                    v-if="userType == 'Individual'"
                  >Uploaded Scanned copy of personal identification card</span>
                  <span
                    style="font-size:12px;"
                    v-if="userType == 'Company'"
                  >Uploaded Scanned copy of company registration documents</span>
                </v-flex>
              </v-layout>

              <v-layout v-if="editProfile" wrap pt-3 justify-space-around>
                <v-flex xs12 md5 pt-2 text-center>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12>
                      <span style="font-size:12px;">Front</span>
                    </v-flex>
                    <v-flex py-2 xs12 sm12 md12>
                      <v-btn
                        rounded
                        small
                        :ripple="false"
                        id="sup_front"
                        class="text-capitalize"
                        outlined
                        color="#26af82"
                        width="120"
                        @click="$refs.uploadsupfrnt.click()"
                      >
                        Upload
                        <v-img
                          src="../../assets/icons/upload.png"
                          aspect-ratio="1"
                          contain
                          height="20px"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-btn>
                      <input
                        v-show="false"
                        ref="uploadsupfrnt"
                        accept="image/*"
                        type="file"
                        @change="uploadsupfrnt"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="height:150px;background-color:#ececec;"
                      align="center"
                      text-center
                    >
                      <v-img
                        v-if="supdocfrntimg"
                        id="supFront"
                        :src="supdocfrntimg"
                        aspect-ratio="1"
                        contain
                        height="100%"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md5 pt-2 text-center>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12>
                      <span style="font-size:12px;">Back</span>
                    </v-flex>
                    <v-flex py-2 xs12 sm12 md12>
                      <v-btn
                        rounded
                        small
                        dark
                        id="sup_back"
                        :ripple="false"
                        class="text-capitalize"
                        outlined
                        color="#26af82"
                        width="120"
                        @click="$refs.uploadsupback.click()"
                      >
                        Upload
                        <v-img
                          src="../../assets/icons/upload.png"
                          aspect-ratio="1"
                          contain
                          height="20px"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-btn>
                      <input
                        v-show="false"
                        ref="uploadsupback"
                        :rules="[rules.required]"
                        accept="image/*"
                        type="file"
                        @change="uploadsupback"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="height:150px;background-color:#ececec;"
                      align="center"
                      text-center
                    >
                      <v-img
                        v-if="supdocbackimg"
                        id="supBack"
                        :src="supdocbackimg"
                        aspect-ratio="1"
                        contain
                        height="100%"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout v-if="!editProfile" pt-4 wrap justify-center>
                <v-flex xs12 md12 v-for="(item, i) in supDocs" v-bind:key="i">
                  <span v-if="item.type=='Supporting Document'">{{++i}}. {{item.orginalname}}</span>
                  <span v-else>{{++i}}. {{item.orginalname}} (Accreditation Note)</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout pa-4 v-if="editProfile" wrap justify-center>
            <v-flex text-right>
              <v-btn
                text
                class="text-capitalize"
                dark
                :ripple="false"
                color="#26af82"
                @click="submit"
              >Submit</v-btn>
              <v-btn
                text
                class="text-capitalize"
                dark
                :ripple="false"
                color="#26af82"
                @click="editProfile=false"
              >Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["profileDat"],
  data() {
    return {
      appLoading: false,
      appLoading2: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      ServerError: false,
      profileData: [],
      supDocNo: null,
      editProfile: false,
      userId: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters"
      },

      userType: localStorage.getItem("userType"),
      supDocs: [],
      supdocfrntimg: null,
      supdocbackimg: null,
      supdocfrntname: null,
      supdocbackname: null,
      supdocfrnt: null,
      supdocback: null,
      supfrntsts: false,
      supbacksts: false,
      supportingDocs: [],
      supportingDoc: null
    };
  },
  beforeMount() {
    if (this.profileDat.type == "Individual") {
      this.supDocNo = this.profileDat.individual.supportingEvidence;
      this.country = this.profileDat.address.country;
      this.getSupDocs();
    }
    if (this.profileDat.type == "Company") {
      this.supDocNo = this.profileDat.company.registrationNumber;
    }
    this.supDocs = this.profileDat.documents;
    this.userId = this.profileDat._id;
  },
  methods: {
    getProfile() {
      this.appLoading2 = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.profileData = response.data.data;
          if (response.data.data.type == "Individual") {
            this.supDocNo = response.data.data.individual.supportingEvidence;
          }
          if (response.data.data.type == "Company") {
            this.supDocNo = response.data.data.company.registrationNumber;
          }

          this.supDocs = response.data.data.documents;
          this.userId = response.data.data._id;
          this.appLoading2 = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getSupDocs() {
      axios({
        method: "GET",
        url: "/country/getbyname",
        params: {
          country: this.country
        }
      })
        .then(response => {
          this.supportingDocs = response.data.data.evidence;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.editProfile = false;
      if (this.supfrntsts && !this.supbacksts) this.singleFileUpload();
      else if (!this.supfrntsts && this.supbacksts) this.singleFileUpload();
      else if (this.supfrntsts && this.supbacksts) this.uploadDocs();
    },
    submit2() {
      this.appLoading = true;
      this.profileData = {};
      if (this.userType == "Individual") {
        this.profileData.supportingEvidence = this.supDocNo;
      }
      if (this.userType == "Company") {
        this.profileData.registrationNumber = this.supDocNo;
      }
      this.profileData.id = this.userId;
      this.profileData.profilecomplete = true;
      axios({
        method: "POST",
        url: "/user/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.profileData
      })
        .then(response => {
          this.editProfile = false;
          if (this.supfrntsts && !this.supbacksts) this.singleFileUpload();
          else if (!this.supfrntsts && this.supbacksts) this.singleFileUpload();
          else if (this.supfrntsts && this.supbacksts) this.uploadDocs();
          else this.getProfile();
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },

    uploadsupfrnt(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.supdocfrnt = e.target.files[0];
      this.supdocfrntname = e.target.files[0].name;
      var reader = new FileReader();
      reader.onload = e => {
        this.supdocfrntimg = e.target.result;
      };
      this.supfrntsts = true;
      reader.readAsDataURL(files[0]);
    },
    uploadsupback(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.supdocback = e.target.files[0];
      this.supdocbackname = e.target.files[0].name;
      var reader = new FileReader();
      reader.onload = e => {
        this.supdocbackimg = e.target.result;
      };
      this.supbacksts = true;
      reader.readAsDataURL(files[0]);
    },
    singleFileUpload() {
      let formData = new FormData();
      if (this.supfrntsts) {
        formData.append("doc", this.supdocfrnt);
        formData.append("type", "Supporting Document");
        formData.append("remark", "front");
        formData.append("filenm", this.supdocfrntname);
      }
      if (this.supbacksts) {
        formData.append("doc", this.supdocback);
        formData.append("type", "Supporting Document");
        formData.append("remark", "back");
        formData.append("filenm", this.supdocbackname);
      }
      if (this.userType == "Individual") {
        formData.append("name", this.supportingDoc);
      }
      if (this.userType == "Company") {
        formData.append("name", "Company Registration Doc");
      }
      formData.append("completeprofile", true);
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/Uploaddocument",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.appLoading = false;
          this.supdocfrntimg = null;
          this.supdocbackimg = null;
          this.supdocfrntname = null;
          this.supdocbackname = null;
          this.supdocfrnt = null;
          this.supdocback = null;
          this.supfrntsts = false;
          this.supbacksts = false;
          this.msg = response.data.msg;
          this.msg = "Succesfully Updated";
          this.showsnackbar = true;
          this.getProfile();
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    uploadDocs() {
      let formData = new FormData();
      formData.append("front", this.supdocfrnt);
      formData.append("back", this.supdocback);
      formData.append("type", "Supporting Document");
      formData.append("completeprofile", true);
      if (this.userType == "Individual") {
        formData.append("name", "aadhar");
      }
      if (this.userType == "Company") {
        formData.append("name", "Company Registration Doc");
      }
      formData.append("frontname", this.supdocfrntname);
      formData.append("backname", this.supdocbackname);
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/upload/allsupportdocs",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.supdocfrntimg = null;
          this.supdocbackimg = null;
          this.supdocfrntname = null;
          this.supdocbackname = null;
          this.supdocfrnt = null;
          this.supdocback = null;
          this.supfrntsts = false;
          this.supbacksts = false;
          this.msg = response.data.msg;
          this.msg = "Succesfully Updated";
          this.showsnackbar = true;
          this.appLoading = false;
          this.getProfile();
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>